"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var dealInsurance = {
    DEAL_INSURANCE: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment DealInsurance on DealInsurance {\n      applicationStatus\n      input {\n        estimate\n        dateOfBirth\n        noClaimsDiscount\n      }\n      policy {\n        type\n        money {\n          currency\n          amount\n        }\n      }\n    }\n  "], ["\n    fragment DealInsurance on DealInsurance {\n      applicationStatus\n      input {\n        estimate\n        dateOfBirth\n        noClaimsDiscount\n      }\n      policy {\n        type\n        money {\n          currency\n          amount\n        }\n      }\n    }\n  "]))),
};
exports.default = dealInsurance;
var templateObject_1;
